@if (message(); as msg) {
  <!-- Keyed by id: a newer push re-creates the card, which replays the slide-in. -->
  @for (m of [msg]; track m.id) {
    <div class="co-push-alert" role="status" aria-live="polite">
      <button
        type="button"
        class="co-push-alert-card flex w-full items-start gap-3 text-left"
        aria-label="Tutup notifikasi"
        (click)="dismiss()"
      >
        <span class="grid h-9 w-9 shrink-0 place-items-center rounded-full" [class]="icon().tone">
          <ion-icon aria-hidden="true" class="h-5 w-5" [name]="icon().name"></ion-icon>
        </span>

        <span class="min-w-0 flex-1">
          <span class="block text-[14px] font-bold leading-[21px] text-[#1F1F1F]">
            {{ m.title || 'Travelpath' }}
          </span>
          @if (m.body) {
            <span class="mt-1 line-clamp-2 block text-[13px] leading-[20px] text-[#4B4B4B]">
              {{ m.body }}
            </span>
          }
        </span>

        <ion-icon
          aria-hidden="true"
          class="mt-[2px] h-5 w-5 shrink-0 text-[#7C7C7C]"
          name="close"
        ></ion-icon>
      </button>
    </div>
  }
}
